import "./App.css";
import Main from "./components/Main";

function App() {
  return (
    <div className="App" style={{ height: window.innerHeight }}>
      <Main />
    </div>
  );
}

export default App;
